import { t } from 'i18next';
import { Navigate } from 'react-router-dom';
import { PATHS } from '../../routing/routes';
import { ErrorNotification } from '../utils/notifications/Notification';
import { BaseController, BaseState } from './BaseController';

type Props = {};

type State = BaseState & {};

export class NotFoundController extends BaseController<Props, State> {
  componentDidMount(): void {
    super.componentDidMount();

    this.showMessage(new ErrorNotification(t('nonExistingPage')));
  }

  render() {
    return <Navigate to={PATHS.ROOT} replace={true} />;
  }
}
